// @ts-ignore
import { orgAxios } from '../api/axios';

export const PhoService = {
  getModulesByPhoId,
  getCandidatePhoProgress,
  postCandidatePhoProgress,
  postCandidateHiringStage,
  markPhoComplete,
  resetPhoProgress,
  getAppConfig,
};

/**
 * Request body interface for updating candidate hiring stages
 */
export interface HiringStageBody {
  candidatesInput: Array<{
    candidateId: string;
    hiringStage: string;
  }>;
  modifiedBy: string;
  actionType: string;
}

/**
 * Request body interface for posting candidate PHO progress
 */
export interface PostCandidateProgressBody {
  phoId: string;
  candidateId: string;
  applicationId: string;
  moduleId: string;
  phoProgress: string;
  phoStatus: string;
}

/**
 * Request body interface for candidate progress operations
 */
export interface CandidateProgressBody {
  phoId: string;
  candidateId: string;
  applicationId: string;
}

/**
 * Request body interface for fetching PHO modules
 */
export interface ModulesBody {
  phoId: string;
  locale: string;
}

async function getAppConfig() {
  // @ts-ignore
  return await orgAxios.get('/getAppConfig');
}

async function getModulesByPhoId(body: ModulesBody) {
  // @ts-ignore
  return await orgAxios.get('/pho/modulesById', {
    params: { phoId: body.phoId, locale: body.locale },
  });
}

async function getCandidatePhoProgress(body: CandidateProgressBody) {
  // @ts-ignore
  return await orgAxios.get('/pho/progress', {
    params: { phoId: body.phoId, candidateId: body.candidateId, applicationId: body.applicationId },
  });
}

async function postCandidatePhoProgress(body: PostCandidateProgressBody) {
  // @ts-ignore
  return await orgAxios.post('/pho/progress', body);
}

async function postCandidateHiringStage(body: HiringStageBody) {
  // @ts-ignore
  return await orgAxios.post('/candidate/application/hiringStage', body);
}

async function markPhoComplete(body: CandidateProgressBody) {
  // @ts-ignore
  return await orgAxios.put('/pho/complete', body);
}

async function resetPhoProgress(body: CandidateProgressBody) {
  // @ts-ignore
  return await orgAxios.put('/pho/reset', body);
}
